import { Tournament } from 'functions/src/types/firestore/Game/Tournament';

export const isNotCheckedIn = (
  {
    guestlistAggregated,
    waitlistAggregated,
  }: Pick<Tournament<Date>, 'guestlistAggregated' | 'waitlistAggregated'>,
  userId: string,
) => {
  const fullListAggregated = [...guestlistAggregated, ...waitlistAggregated];
  return fullListAggregated?.some((team) => {
    return (
      team.acceptedUserIds?.includes(userId) &&
      team.members.some((member) => {
        return member.userId === userId && member.checkedIn === false;
      })
    );
  });
};
